import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function KidsTaekwondoScheduleLocation() {
  return <section className="py-24 bg-off-white" data-id="element-2250">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2251">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-2252">
          <div data-id="element-2253">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2254">Class Times</h2>
            <ScheduleTable data-id="element-2255" />
          </div>
          <div data-id="element-2256">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2257">
              Taekwondo Classes in Farmington Hills, MI
            </h2>
            <LocationBlock data-id="element-2258" />
          </div>
        </div>
      </div>
    </section>;
}